import { useI18n } from '@/hooks/useI18n';
import styles from './FeatureComparison.module.css';

export function FeatureComparison() {
  const { t } = useI18n();
  const c = t.marketing.comparison;

  return (
    <section className={['ilu-section', styles.section].join(' ')} id="comparativa">
      <div className="ilu-container">
        <span className="ilu-eyebrow">{c.eyebrow}</span>
        <h2 className="ilu-section-title">{c.title}</h2>

        <div className={styles.tableWrap} tabIndex={0}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th scope="col">{c.colFeature}</th>
                <th scope="col">{c.colSoloBrand}</th>
                <th scope="col">{c.colSmartPartner}</th>
              </tr>
            </thead>
            <tbody>
              {t.marketing.comparisonRows.map((row) => (
                <tr key={row.id}>
                  <th scope="row" className={styles.feature}>
                    {row.feature}
                  </th>
                  <td className={row.soloBrandMissing ? styles.missing : styles.value}>
                    {row.soloBrand}
                  </td>
                  <td className={styles.highlight}>{row.smartPartner}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
